import { useMemo } from 'react';
import { useGameStore } from '../GameStoreContext.ts';
import { usePlayerValidators } from './usePlayerValidators.ts';
import { MechanicValidatorCityWall } from '@colonist/game-mechanic-validators';
import { useMapValidator } from './useMapValidator.ts';
export const useMechanicValidatorCityWall = ()=>{
    const { playerValidators } = usePlayerValidators();
    const mapValidator = useMapValidator();
    const mechanicCityWallState = useGameStore((state)=>state.gameState.mechanicCityWallState);
    return useMemo(()=>{
        if (!mechanicCityWallState) return undefined;
        return new MechanicValidatorCityWall(playerValidators, mapValidator, mechanicCityWallState);
    }, [
        playerValidators,
        mapValidator,
        mechanicCityWallState
    ]);
};
